import { render, staticRenderFns } from "./CustomerListPk.vue?vue&type=template&id=c595a516&scoped=true"
import script from "./CustomerListPk.vue?vue&type=script&lang=js"
export * from "./CustomerListPk.vue?vue&type=script&lang=js"
import style0 from "./CustomerListPk.vue?vue&type=style&index=0&id=c595a516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c595a516",
  null
  
)

export default component.exports